"use client";

import {
  shippingDestinationOptions,
  shippingDestinationSchema,
  type ShippingDestination,
} from "@/domain/cart/shipping-destination";

export interface CartDestinationFieldProps {
  readonly onChange: (destination: ShippingDestination) => void;
  readonly value: ShippingDestination;
}

export function CartDestinationField({
  onChange,
  value,
}: Readonly<CartDestinationFieldProps>) {
  return (
    <div className="text-sm font-bold text-muted">
      <label htmlFor="shipping-destination">Departamento de envío</label>
      <span className="mt-2 flex min-h-12 overflow-hidden rounded-lg border border-outline-variant bg-surface focus-within:border-primary focus-within:ring-1 focus-within:ring-primary">
        <select
          aria-describedby="shipping-destination-help"
          className="min-w-0 flex-1 bg-transparent px-3 text-base font-bold text-foreground outline-none"
          id="shipping-destination"
          name="shippingDestination"
          onChange={(event) => {
            const destination = shippingDestinationSchema.safeParse(event.target.value);

            if (destination.success) {
              onChange(destination.data);
            }
          }}
          value={value}
        >
          {shippingDestinationOptions.map((option) => (
            <option key={option.key} value={option.key}>
              {option.label}
            </option>
          ))}
        </select>
      </span>
      <span
        className="mt-1 block text-xs font-normal text-muted"
        id="shipping-destination-help"
      >
        Selecciona el departamento donde quieres recibir tu pedido.
      </span>
    </div>
  );
}
